import KeyMirror from "keymirror";

/**
 * @typedef {string} StatisticsDataTypes
 **/

/**
 * @enum {StatisticsDataTypes}
 */
const StatisticsDataTypes = KeyMirror({
  DOMAIN_TRACKED_URLS: null,
  DOMAIN_SCRAPED_JOBS: null,
  USER_TRACKED_URLS: null,
  USER_SCRAPED_JOBS: null,
});

export default StatisticsDataTypes;
